import { UnsavedChangesProtection } from 'v5/patterns/forms/unsaved-changes/UnsavedChangesProtection';
import { Dialog, DialogContentHeadless } from 'v5/design-system/Dialog';
import type { EnterpriseWorkspace } from 'v5/api/enterprise/enterprise.api';
import { MountElementProps } from 'v5/messages/mount-element';
import { WithServices } from 'v5/platform/ts/services';
import { WithToastService } from 'v5/services/front/ToastService/ToastService';
import { WithUploadService } from 'v5/services/io/UploadService/UploadService';
import {
  EnterpriseWorkspaceDialogContent,
  EnterpriseWorkspaceFormData
} from './EnterpriseWorkspaceDialogContent';

export type EditEnterpriseWorkspaceDialogProps = MountElementProps &
  WithServices<[WithUploadService, WithToastService]> & {
    workspace: EnterpriseWorkspace;
    onSubmit?: (data: EnterpriseWorkspaceFormData) => Promise<void> | void;
  };

export function EditEnterpriseWorkspaceDialog({
  open,
  onOpenChange,
  close,
  workspace,
  onSubmit,
  services
}: EditEnterpriseWorkspaceDialogProps) {
  return (
    <UnsavedChangesProtection
      open={open}
      onOpenChange={onOpenChange}
      beforeUnloadMessage="You have unsaved changes!"
    >
      {dialogProps => (
        <Dialog {...dialogProps}>
          <DialogContentHeadless className="max-w-150">
            <EnterpriseWorkspaceDialogContent
              workspace={workspace}
              open={dialogProps.open}
              services={services}
              onSubmit={async data => {
                await onSubmit?.(data);
                close();
              }}
            />
          </DialogContentHeadless>
        </Dialog>
      )}
    </UnsavedChangesProtection>
  );
}
